import { render, staticRenderFns } from "./CompanyDefault.vue?vue&type=template&id=408eebc1"
import script from "./CompanyDefault.vue?vue&type=script&lang=js"
export * from "./CompanyDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports